import React, { useState, useEffect, useRef } from 'react'
import '../App.css'
import DragAndDropUpload from '../components/Upload/DragAndDropUpload.js';
import useDragAndDrop from "../hooks/UseDragAndDrop.js";
import QuestionForm from '../components/QuestionForm.js';
import NewChatForm from '../components/NewChatForm.js';
import { useUploadContext } from "../contexts/UploadContext.js";



function AzureOpenAIWrapper({ setActiveComponent, setSelectedConversation }) {

  const [records, setRecords] = useState([]);
  // const addRecord = (question, answer) => {
  //   setRecords([...records, { question: question, response: answer, id: Math.random() }]);
  // };
  const bottomRef = useRef(null);

  // 每當 records 改變時，自動捲動到最底部
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [records]);

  // const [datas, setDatas] = useState([
  //   // { question: '問題1', answer: '回答1', id: Math.random() },
  //   // { question: '問題2', answer: '回答2', id: Math.random() },
  // ]);
  // const addData = (question, answer) => {
  //   setDatas([...datas, { question: question, answer: answer, id: Math.random() }]);
  // };

  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  const { uploadAttachments, updateUploadAttachments } = useUploadContext();
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleFileDrop = (files) => {
    // const newEntries = files.map((file) => ({
    //   fileName: file.name,
    //   file, // 將檔案物件存入
    //   access: "", // 初始為空，submit 時再更新
    //   client: "",
    //   project: "",
    // }));
    // updateUploadData(newEntries); // 將新檔案加入 context
    const newEntries = files.map((file) => ({
      fileName: file.name,
      file, // 儲存檔案物件
      // ...commonData, // 即時同步表單資料
    }));
    updateUploadAttachments(newEntries); // 更新 Context，覆蓋舊檔案
    console.log(uploadAttachments);
  };

  // 自定義 Hook，處理文件拖放邏輯
  const { isDragging, handleDragOver, handleDragLeave, handleDrop } = useDragAndDrop(handleFileDrop);
  // const { isDragging, handleDragOver, handleDragLeave, handleDrop } =
  //   useDragAndDrop((files) => {
  //     // setUploadedFiles((prevFiles) => [...prevFiles, ...files]);

  //     // 處理文件覆蓋邏輯
  //     setUploadedFiles((prevFiles) => {
  //       const fileMap = new Map(prevFiles.map((file) => [file.name, file]));

  //       // 更新或添加新的文件
  //       files.forEach((file) => {
  //         fileMap.set(file.name, file);
  //       });

  //       // 返回最新文件列表
  //       return Array.from(fileMap.values());
  //     });

  //     const newEntries = files.map((file) => ({
  //       fileName: file.name,
  //       file, // 儲存檔案物件
  //       // ...commonData, // 即時同步表單資料
  //     }));
  //     updateUploadData(newEntries); // 更新 Context，覆蓋舊檔案
  //     console.log(uploadData);

  //     // 模擬文件上傳
  //     files.forEach((file) => {
  //       console.log(`Uploading file: ${file.name}`);
  //     });
  //   });

  return (
    <div
      // className="wrapper"
      className={`wrapper ${isDragging ? "dragging" : ""}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {isDragging &&
        <>
          <div className="dragging-overlay" />
          <div className="dragging-hint">
            <div>Add anything</div>
            <div>Drop any file here to add it to the conversation</div>
          </div>
        </>
      }
      <div className="content-container">
        {/* 主內容 (包括 QuestionForm) */}
        <div className={`main-content ${isSidebarVisible ? "shifted" : ""}`}
          style={{
            maxWidth: `calc(100% - ${isSidebarVisible ? "370px" : "0px"})`,
          }}
        >
          <div className="content">
            <div><strong>AI bot</strong></div>
            {/* <div className='question'>{datas[0].question}</div>
              <div className='response'>{datas[0].answer}</div> */}
            {/* {records.map((record) => {
              return <AIReply record={record} />
            })}
            {datas.map((data, index) => {
              return (
                <div key={index}>
                  <div className='question'>{data.question}</div>
                  <div className='response'>
                    {data.answer.split("\n").map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                </div>
              )
            })} */}
            {/* <div className='question'>{datas[datas.length - 1]['question']}</div>
              <div className='response'>{datas[datas.length - 1]['answer']}</div> */}
            {/* 用來觸發自動捲動的元素 */}
            <div ref={bottomRef} />
            <div>
              <NewChatForm
                // uploadedFiles={uploadedFiles} setUploadedFiles={setUploadedFiles}
                isSidebarVisible={isSidebarVisible}
                setIsSidebarVisible={setIsSidebarVisible}
                // setNewChatInput={setNewChatInput}
                setActiveComponent={setActiveComponent}
                setSelectedConversation={setSelectedConversation}
              />
            </div>
            {/* <ul>
          {uploadedFiles.map((file, index) => (
            <li key={index}>{file.name}</li>
          ))}
        </ul> */}
          </div>

        </div>

      </div>
    </div>
  );
}

// function AIReply({data, record}) {
//   return (
//     <>
//       <div className='question'>{record.question}</div>
//       <div className='response'>
//         {/* {record.response} */}
//         {/* <div> */}
//         {record.response.split("\n").map((line, index) => (
//           <p key={index}>{line}</p>
//         ))}
//         {/* </div> */}
//       </div>
//     </>
//   )
// }

export default AzureOpenAIWrapper;